export default __webpack_public_path__ + "static/media/wf.947f086e.svg";